export default "__VITE_PUBLIC_ASSET__9ac5b78e__"